import React from 'react';
import { setContext } from 'apollo-link-context';
import { ApolloProvider } from '@apollo/react-hooks';
import PropTypes from 'prop-types';

import usePersistentClient from './hooks/usePersistentClient';

var CollectionClient = function CollectionClient(props) {
  var middlewareLink = setContext(function () {
    return {
      headers: {
        'X-Shopify-Storefront-Access-Token': 'bef77248a7f2c65f44b1889bf9c3a291'
      }
    };
  });

  var state = usePersistentClient({
    url: '/api/2019-07/graphql.json',
    typeName: 'Collection',
    primaryKey: 'handle',
    middlewareLink: middlewareLink
  });

  if (!state.loaded) {
    return null;
  }
  return React.createElement(
    ApolloProvider,
    { client: state.client },
    props.children
  );
};

CollectionClient.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object])
};

export default CollectionClient;